<section class="tokenomics" aria-labelledby="tokenomics-heading" id="tokenomics">
    <!-- Background glow -->
    <div class="tokenomics__glow" aria-hidden="true"></div>

    <div class="tokenomics__container">
        <!-- ════════════════════════════════════════════════════════════════
         HEADER: Title and Description
         ════════════════════════════════════════════════════════════════ -->
        <div class="tokenomics__header">
            <!-- Protocol DNA Label -->
            <div class="tokenomics__label">
                <div class="tokenomics__label-divider"></div>
                <span class="tokenomics__label-text">{{ 'tokenomics.label' | translate }}</span>
                <div class="tokenomics__label-divider"></div>
            </div>

            <!-- Main Title -->
            <h2 class="tokenomics__title" id="tokenomics-heading">
                <span class="tokenomics__title-primary">{{ 'tokenomics.title_primary' | translate }}</span>
                <span class="tokenomics__title-highlight"> {{ 'tokenomics.title_highlight' | translate }}</span>
            </h2>

            <!-- Description -->
            <p class="tokenomics__description">
                {{ 'tokenomics.description_line1' | translate }}<br>
                <!-- {{ 'tokenomics.description_line2' | translate }} -->
            </p>
        </div>

        <!-- ════════════════════════════════════════════════════════════════
         STATS GRID: 4-column layout with colored top borders
         ════════════════════════════════════════════════════════════════ -->
        <div class="tokenomics__stats-grid">
            <!-- Total Supply -->
            <div class="tokenomics__stat-card tokenomics__stat-card--cyan">
                <div class="tokenomics__stat-label">{{ 'tokenomics.stat1_label' | translate }}</div>
                <div class="tokenomics__stat-value">{{ 'tokenomics.stat1_value' | translate }}</div>
            </div>

            <!-- Circulating Supply -->
            <div class="tokenomics__stat-card tokenomics__stat-card--lime">
                <div class="tokenomics__stat-label">{{ 'tokenomics.stat2_label' | translate }}</div>
                <div class="tokenomics__stat-value">{{ 'tokenomics.stat2_value' | translate }}</div>
            </div>

            <!-- Burn Rate -->
            <!-- <div class="tokenomics__stat-card tokenomics__stat-card--red">
                <div class="tokenomics__stat-label">{{ 'tokenomics.stat3_label' | translate }}</div>
                <div class="tokenomics__stat-value tokenomics__stat-value--red">{{ 'tokenomics.stat3_value' | translate
                    }}</div>
            </div> -->

            <!-- Current Price -->
            <div class="tokenomics__stat-card tokenomics__stat-card--red">
                <div class="tokenomics__stat-label">{{ 'tokenomics.stat4_label' | translate }}</div>
                <div class="tokenomics__stat-value tokenomics__stat-value--cyan">{{ "tokenomics.stat4_value" | translate }}</div>
            </div>
        </div>

        <!-- ════════════════════════════════════════════════════════════════
         MAIN GRID: Utility Section + Distribution Chart
         ════════════════════════════════════════════════════════════════ -->
        <div class="tokenomics__main-grid">
            <!-- LEFT: Systemic Utility Section -->
            <div class="tokenomics__utility-section">
                <div class="tokenomics__utility-header">
                    <h2 class="tokenomics__section-title">{{ 'tokenomics.utility_title' | translate }}</h2>
                </div>

                <!-- 2x2 Grid of Utility Features -->
                <div class="tokenomics__utility-grid">
                    <!-- Governance -->
                    <div class="tokenomics__utility-card">
                        <div class="tokenomics__utility-card-header">
                            <img class="tokenomics__utility-icon" [src]="iconGovernance" alt="Governance"
                                loading="lazy" />
                            <h3 class="tokenomics__utility-card-title">{{ 'tokenomics.utility1_title' | translate }}
                            </h3>
                        </div>
                        <p class="tokenomics__utility-card-text">{{ 'tokenomics.utility1_text' | translate }}</p>
                    </div>

                    <!-- Yield Distribution -->
                    <div class="tokenomics__utility-card">
                        <div class="tokenomics__utility-card-header">
                            <img class="tokenomics__utility-icon" [src]="iconYield" alt="Yield Distribution"
                                loading="lazy" />
                            <h3 class="tokenomics__utility-card-title">{{ 'tokenomics.utility2_title' | translate }}
                            </h3>
                        </div>
                        <p class="tokenomics__utility-card-text">{{ 'tokenomics.utility2_text' | translate }}</p>
                    </div>

                    <!-- Fee Discounts -->
                    <div class="tokenomics__utility-card">
                        <div class="tokenomics__utility-card-header">
                            <img class="tokenomics__utility-icon" [src]="iconFee" alt="Fee Discounts" loading="lazy" />
                            <h3 class="tokenomics__utility-card-title">{{ 'tokenomics.utility3_title' | translate }}
                            </h3>
                        </div>
                        <p class="tokenomics__utility-card-text">{{ 'tokenomics.utility3_text' | translate }}</p>
                    </div>

                    <!-- Constant Burn -->
                    <div class="tokenomics__utility-card">
                        <div class="tokenomics__utility-card-header">
                            <img class="tokenomics__utility-icon" [src]="iconBurn" alt="Constant Burn" loading="lazy" />
                            <p class="tokenomics__utility-card-title">{{ 'tokenomics.utility4_title' | translate }}
                            </p>
                        </div>
                        <p class="tokenomics__utility-card-text">{{ 'tokenomics.utility4_text' | translate }}</p>
                    </div>
                </div>
            </div>

            <!-- RIGHT: Distribution Chart Section -->
            <div class="tokenomics__distribution-section">
                <div class="tokenomics__distribution-header">
                    <h2 class="tokenomics__distribution-title">{{ 'tokenomics.distribution_title' | translate }}</h2>
                </div>

                <div class="tokenomics__chart-wrapper">
                    <!-- Donut Chart -->
                    <div class="tokenomics__chart-container">
                        <img src="/assets/images/webp/chart.webp" class="tokenomics__chart" loading="lazy" alt="chart-image"/>
                        <!-- <svg class="tokenomics__chart" viewBox="0 0 256 256" fill="none"
                            xmlns="http://www.w3.org/2000/svg" class="tokenomics__chart">
                            <g clip-path="url(#clip0_87_115)">
                                <path
                                    d="M128 25.6C151.721 25.6 174.706 33.8355 193.03 48.8997C211.354 63.9639 223.879 84.9225 228.467 108.196C233.054 131.469 229.42 155.613 218.184 176.504C206.948 197.395 188.808 213.737 166.861 222.74C144.915 231.742 120.523 232.845 97.8536 225.862C75.1838 218.878 55.6417 204.241 42.565 184.45C29.4883 164.659 23.6883 140.942 26.1555 117.349C28.6227 93.757 39.2042 71.753 56.0925 55.0956"
                                    stroke="#00D1FF" stroke-width="51.2"></path>
                                <path
                                    d="M56.0925 55.0956C65.6742 45.645 77.0247 38.1758 89.4952 33.1152C101.966 28.0546 115.311 25.5019 128.769 25.6029C142.227 25.704 155.533 28.4569 167.926 33.7042C180.319 38.9515 191.556 46.5903 200.995 56.1838C210.433 65.7772 217.888 77.1372 222.933 89.6139C227.978 102.091 230.514 115.44 230.396 128.897C230.278 142.355 227.509 155.657 222.246 168.044C216.983 180.43 209.33 191.658 199.725 201.084"
                                    stroke="#00FFA3" stroke-width="51.2"></path>
                                <path
                                    d="M199.725 201.084C185.259 215.282 166.904 224.866 146.986 228.624C127.069 232.383 106.484 230.145 87.8385 222.196C69.1933 214.246 53.3268 200.942 42.2484 183.968C31.1701 166.994 25.3783 147.114 25.6066 126.847"
                                    stroke="#00CFFC" stroke-width="51.2"></path>
                                <path
                                    d="M25.6066 126.847C25.8349 106.579 32.0731 86.8344 43.531 70.1145C54.9889 53.3946 71.1512 40.4512 89.9707 32.9236C108.79 25.396 129.42 23.6229 149.248 27.8289C169.076 32.0348 187.21 42.0305 201.353 56.5501"
                                    stroke="#FF716B" stroke-width="51.2"></path>
                                <path
                                    d="M201.353 56.5501C210.744 66.1907 218.142 77.5878 223.124 90.0897C228.106 102.592 230.576 115.953 230.39 129.41C230.205 142.867 227.369 156.155 222.044 168.515C216.719 180.875 209.01 192.064 199.358 201.442"
                                    stroke="#45484C" stroke-width="51.2"></path>
                                <path
                                    d="M199.358 201.442C189.706 210.821 178.299 218.205 165.791 223.171C153.283 228.138 139.919 230.591 126.462 230.388"
                                    stroke="#A9ABAF" stroke-width="51.2"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_87_115">
                                    <rect width="256" height="256" fill="white" transform="matrix(0 -1 1 0 0 256)">
                                    </rect>
                                </clipPath>
                            </defs>
                        </svg> -->
                        <!-- Center Text Overlay -->
                        <div class="tokenomics__chart-overlay">
                            <div class="tokenomics__chart-value">{{ 'tokenomics.chart_value' | translate }}</div>
                            <div class="tokenomics__chart-label">{{ 'tokenomics.chart_label' | translate }}</div>
                        </div>
                    </div>

                    <!-- Distribution Legend -->
                    <div class="tokenomics__legend">
                        <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--red"></div>
                            <span class="tokenomics__legend-percent">40%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist1_label' | translate }}</span>
                        </div>
                        <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--lime"></div>
                            <span class="tokenomics__legend-percent">24%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist2_label' | translate }}</span>
                        </div>
                        <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--cyan"></div>
                            <span class="tokenomics__legend-percent">15%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist3_label' | translate }}</span>
                        </div>
                        <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--grey"></div>
                            <span class="tokenomics__legend-percent">15%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist4_label' | translate }}</span>
                        </div>
                        <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--light-grey"></div>
                            <span class="tokenomics__legend-percent">6%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist5_label' | translate }}</span>
                        </div>
                        <!-- <div class="tokenomics__legend-item">
                            <div class="tokenomics__legend-dot tokenomics__legend-dot--light-grey"></div>
                            <span class="tokenomics__legend-percent">5%</span>
                            <span class="tokenomics__legend-label">{{ 'tokenomics.dist6_label' | translate }}</span>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- ════════════════════════════════════════════════════════════════
         STAKING INFRASTRUCTURE
         ════════════════════════════════════════════════════════════════ -->
        <!-- <div class="tokenomics__staking-section">
            <div class="tokenomics__staking-content">
                <div class="tokenomics__staking-left">
                    <h2 class="tokenomics__staking-title">{{ 'tokenomics.staking_title' | translate }}</h2>
                    <p class="tokenomics__staking-description">
                        {{ 'tokenomics.staking_desc1' | translate }}
                    </p>

                    <div class="tokenomics__apy-stats">
                        <div class="tokenomics__apy-card">
                            <div class="tokenomics__apy-label">{{ 'tokenomics.apy_standard_label' | translate }}</div>
                            <div class="tokenomics__apy-value">{{ 'tokenomics.apy_standard_value' | translate }}</div>
                        </div>
                        <div class="tokenomics__apy-card tokenomics__apy-card--highlight">
                            <div class="tokenomics__apy-label">{{ 'tokenomics.apy_max_label' | translate }}</div>
                            <div class="tokenomics__apy-value">{{ 'tokenomics.apy_max_value' | translate }}</div>
                        </div>
                    </div>

                    <a [routerLink]="currentLanguage !== 'en' ? currentLanguage + '/staking' : 'staking'" class="text-center tokenomics__cta-button" aria-label="Stake SEERX">
                        {{ 'tokenomics.stake_button' | translate }}
                    </a>
                </div>
                
                <div class="tokenomics__staking-chart">
                    <div class="tokenomics__chart-legend">
                        <div class="tokenomics__chart-legend-item">
                            <div class="tokenomics__chart-legend-dot tokenomics__chart-legend-dot--alpha"></div>
                            <span>{{ 'tokenomics.chart_alpha' | translate }}</span>
                        </div>
                        <div class="tokenomics__chart-legend-item">
                            <div class="tokenomics__chart-legend-dot tokenomics__chart-legend-dot--v2"></div>
                            <span>{{ 'tokenomics.chart_v2' | translate }}</span>
                        </div>
                    </div>
                    <div class="tokenomics__bar-chart">
                        <div class="tokenomics__bar tokenomics__bar--1"></div>
                        <div class="tokenomics__bar tokenomics__bar--2"></div>
                        <div class="tokenomics__bar tokenomics__bar--3"></div>
                        <div class="tokenomics__bar tokenomics__bar--4"></div>
                        <div class="tokenomics__bar tokenomics__bar--5"></div>
                        <div class="tokenomics__bar tokenomics__bar--6"></div>
                        <div class="tokenomics__bar tokenomics__bar--7"></div>
                        <div class="tokenomics__bar tokenomics__bar--8"></div>
                        <div class="tokenomics__bar tokenomics__bar--9"></div>
                        <div class="tokenomics__bar tokenomics__bar--10"></div>
                        <div class="tokenomics__bar tokenomics__bar--11"></div>
                    </div>

                
                </div>
            </div>
        </div> -->

        <!-- ════════════════════════════════════════════════════════════════
         BURN PROTOCOL & CIRCULATION LOCK-UP
         ════════════════════════════════════════════════════════════════ -->
        <!-- <div class="tokenomics__mechanics-grid">
            <div class="tokenomics__mechanic-card tokenomics__mechanic-card--burn">
                <div class="tokenomics__mechanic-header">
                    <div>
                        <div class="tokenomics__mechanic-title">{{ 'tokenomics.burn_title' | translate }}</div>
                        <div class="tokenomics__mechanic-subtitle">{{ 'tokenomics.burn_subtitle' | translate }}</div>
                    </div>
                    <div class="tokenomics__mechanic-badge tokenomics__mechanic-badge--burn">
                        {{ 'tokenomics.burn_status' | translate }}
                    </div>
                </div>

                <div class="tokenomics__mechanic-content">
                    <div class="tokenomics__mechanic-stat">
                        <span class="tokenomics__mechanic-stat-label">{{ 'tokenomics.burn_stat_label' | translate
                            }}</span>
                        <span class="tokenomics__mechanic-stat-value">{{ 'tokenomics.burn_stat_value' | translate
                            }}</span>
                    </div>

                    <div class="tokenomics__progress-bar tokenomics__progress-bar--burn">
                        <div class="tokenomics__progress-fill"></div>
                    </div>

                    <p class="tokenomics__mechanic-note">
                        {{ 'tokenomics.burn_note' | translate }}
                    </p>
                </div>
            </div>

            <div class="tokenomics__mechanic-card tokenomics__mechanic-card--circulation">
                <div class="tokenomics__mechanic-header">
                    <div>
                        <div class="tokenomics__mechanic-title">{{ 'tokenomics.circulation_title' | translate }}</div>
                        <div class="tokenomics__mechanic-subtitle">{{ 'tokenomics.circulation_subtitle' | translate }}
                        </div>
                    </div>
                    <div class="tokenomics__mechanic-badge tokenomics__mechanic-badge--circulation">
                        {{ 'tokenomics.circulation_status' | translate }}
                    </div>
                </div>

                <div class="tokenomics__mechanic-content">
                    <div class="tokenomics__mechanic-stat">
                        <span class="tokenomics__mechanic-stat-label">{{ 'tokenomics.circulation_stat_label' | translate
                            }}</span>
                        <span class="tokenomics__mechanic-stat-value">{{ 'tokenomics.circulation_stat_value' | translate
                            }}</span>
                    </div>

                    <div class="tokenomics__progress-bar tokenomics__progress-bar--circulation">
                        <div class="tokenomics__progress-fill"></div>
                    </div>

                    <p class="tokenomics__mechanic-note">
                        {{ 'tokenomics.circulation_note' | translate }}
                    </p>
                </div>
            </div>
        </div> -->
    </div>
</section>